import { Link } from 'react-router-dom'

import { Me } from 'api/types'
import { roleLabel } from 'lib/format'

import { Avatar } from '../atoms/Avatar'
import { useActiveProject } from '../context/ActiveProjectContext'
import { useRegion } from '../context/RegionContext'

export const UserCard = ({ user }: { user: Me | null }) => {
  const activeProject = useActiveProject()
  const { locale } = useRegion()
  const roleText = user?.isAdmin ? roleLabel('ADMIN', locale) : activeProject ? roleLabel(activeProject.myRole, locale) : ''

  return (
    <Link to="/profile" className="shell__user">
      <Avatar initial={user?.name?.trim().slice(0, 1) ?? (locale === 'en' ? '?' : '؟')} />
      <span className="shell__user-info">
        <strong>{user?.name}</strong>
        <small>{roleText}</small>
      </span>
    </Link>
  )
}
